// @flow
import "isomorphic-unfetch";
import fetchJsonp from "fetch-jsonp";
import qs from "qs";
import { isString } from "voca";

const doRequest = async (url: string, params: Object) => {
	let result: Object;

	try {
		const response: Object = await fetch(url, params);

		if (!response.ok) {
			result = Promise.reject(response);
		} else {
			result = await response.json();
		}
	} catch (error) {
		result = Promise.reject(error);
	}

	return result;
};

/**
 * callApi
 * @param endpoint
 * @param options
 * @returns {Promise.<{}>}
 */
export const callApi = async (endpoint: string, options: Object = {}): Promise<any> => {
	const url: string = endpoint;
	const query = options.query && (isString(options.query)
		? options.query
		: qs.stringify(options.query));

	const fullUrl: string = options.query // Include a querystring.
		? `${url}?${query}`
		: url;

	const defaults: Object = { // Set request defaults.
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
			...options.headers,
		},
	};

	if (options.noCors === true) {
		options.mode = "no-cors";
	}

	if (options.body) { // Set request body params.
		options.body = JSON.stringify(options.body);
	}

	const params: Object = { ...defaults, ...options }; // merge with defaults

	return await doRequest(fullUrl, params);
};

/**
 * get
 * @param endpoint
 * @param query
 */
export const get: Function = (endpoint: string, query: Object = {}, options: Object = {}) => callApi(endpoint, { query, ...options });

/**
 * post
 * @param endpoint
 * @param body
 */
export const post: Function = (endpoint: string, body: Object, options: Object = {}) => callApi(endpoint, { method: "POST", body, ...options });

/**
 * put
 * @param endpoint
 * @param body
 */
export const put: Function = (endpoint: string, body: Object, options: Object = {}) => callApi(endpoint, { method: "PUT", body, ...options });

/**
 * patch
 * @param endpoint
 * @param body
 */
export const patch: Function = (endpoint: string, body: Object, options: Object = {}) => callApi(endpoint, { method: "PATCH", body, ...options });

/**
 * delete
 * @param endpoint
 * @param body
 */
export const del: Function = (endpoint: string, body: Object, options: Object = {}) => callApi(endpoint, { method: "DELETE", body, ...options });

/**
 * jsonp
 * @param endpoint
 */
export const jsonp: Function = (endpoint: string) => fetchJsonp(endpoint)
	.then((response) => response.json());

/**
 * preloads image
 * @param url
 * @returns
 */
export const preloadImage: Function = async (url: string) => await fetch(url);
